'use client';

import { PropsWithChildren, useEffect } from 'react';

export const REDDIT_CLASSNAME = 'reddit-embed-bq';

const RedditEmbedContainer = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const existing = document.querySelector(
      'script[src="https://embed.reddit.com/widgets.js"]',
    );
    if (existing) {
      (window as any).reddit?.init?.();
    } else {
      const script = document.createElement('script');
      script.src = 'https://embed.reddit.com/widgets.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return <div>{children}</div>;
};

export default RedditEmbedContainer;
